import useLenis from "@/hooks/useLenis";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import Work from "@/components/site/Work";
import Services from "@/components/site/Services";
import InsideLab from "@/components/site/InsideLab";
import FromLab from "@/components/site/FromLab";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useLenis();

  return (
    <main data-testid="landing-page" className="relative bg-[#090514]">
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <Work />
      <Services />
      <InsideLab />
      <FromLab />
      <Contact />
      <Footer />
    </main>
  );
}
